// extracted by mini-css-extract-plugin
export default {"artefactContainer":"Artefact_artefactContainer__T45zD","artefactImage":"Artefact_artefactImage__cWk46","artefactOverlay":"Artefact_artefactOverlay__iVQFr"};